export default __webpack_public_path__ + "static/media/islamic.8bc834e1.svg";